export default __webpack_public_path__ + "static/media/Suggestedoffer.61df9e6f.svg";